export const lang = {
  common: {
    play: 'Play',
    viewMore: 'View More',
    currency: 'Currency',
    fail: 'Fail',
    success: 'Success',
    downLoad: 'Download'
  },
  menu: {
    Home: '首页',
    Games: 'Games',
    Promotion: 'Promotion',
    FAQ: 'FAQ',
    Deposit: 'Deposit',
    Withdraw: 'Withdraw',
    Account: 'Account',
    Edit: 'Edit Info',
    History: 'History',
    Message: 'Message',
    Support: 'Support',
    Terms: 'Terms and Conditions',
    Privacy: 'Privacy Policy',
    Responsible: 'Responsible Gambling',
    AboutUs: 'About Us',
    News: 'News',
    Kyc: 'KYC政策'
  },
  label: {
    POPULAR: 'MOST POPULAR',
    CASINO: 'LIVE CASINO',
    LOTTERY: 'LOTTERY',
    FISHING: 'FISHING GAMES',
    SLOTS: 'SLOTS',
    hot: 'Hot',
    live: 'Live Dealers',
    lottery: 'Lottery',
    fishing: 'Fishing',
    slots: 'Slots',
    casino: 'Live Casino'
  },
  promotion: {
    title1: '100% DEPOSIT BONUS',
    desc1_1: 'Receive 100% Bonus on your Deposit!',
    desc1_2: 'Wagering 30X',
    desc1_3: 'One time use only | No Deposit Limits',
    title2: 'OCTOBER MADNESS',
    desc2_1: '₹2.5m each for Top 3 Biggest Daily Winners in October!',
    desc2_2: 'Paid out instantly on 31st October',
    title3: 'Lucky Wednesday',
    desc3_1: 'PGEbet Big Reward',
    desc3_2: '150% Bonus for every deposit you make on every Wednesday!',
    title4: 'Invite and Earn ₹',
    desc4_1: '①<div style="margin-left: 10px;flex: 1;text-align: left;">Get an instant ₹10 for inviting each friend to sign up and play.</div>',
    desc4_2: '②<div style="margin-left: 10px;flex: 1;text-align: left;">Get 5% of every deposit your friend makes and another ₹500 if his/her total deposit is over ₹10,000.</div>',
    desc4_3: '③<div style="margin-left: 10px;flex: 1;text-align: left;">Total rewards up to ₹100 Million!</div>',
    title5: '10 Big Winners Month',
    desc5_1: 'During the promotion period, the top 10 players who win most will be able to share over 10m rupees in cash rewards!',
    title6: 'Stay Online and Win Cash',
    desc6_1: 'Stay on the PGEbet app for over 1 hour every day for 7 consecutive days to win 100 rupees.',
    promotionDuration: 'Promotion Duration: ',
    duration1: '1 month'
  },
  winner: {
    justWon: 'just won',
    playing: 'playing'
  },
  login: {
    login: 'LOG IN',
    register: 'Register',
    recover: 'Recover Password',
    reset: 'Reset Password',
    email: 'Email',
    password: 'Password',
    continue: 'or continue with',
    forget: 'Forget password',
    username: 'User Name',
    Username: 'Username',
    invalid: 'Invalid Mobile Number',
    depositCur: 'Deposit Currency',
    Recover: 'Recover',
    Reset: 'Reset',
    Submit: 'Submit'
  },
  message: {
    emailActivate: 'Error occurs when activate email',
    inputEmail: 'Please input email',
    inputPassword: 'Please input password',
    inputUsername: 'Please input user name',
    inputValid: 'Please input valid email address',
    passwordMust: 'Password must be 8-18 bit and include number, alphabet and special character',
    notRegister: 'This email is not register',
    notCorrect: 'Password is not correct',
    registerSuccess: 'Register successfully',
    usernameExit: 'Username existed',
    emailExit: 'Email existed',
    mobileExit: 'Mobile existed',
    accountSuspended: 'Your account has been suspended due to abnormal activities. Please contact support@pgebet.com',
    registerFail: 'Register fail. Please retry or contact support@pgebet.com'
  },
  active: {
    emailActive: 'Email Active',
    activating: 'Activating your email'
  },
  account: {
    totalBalance: 'Total Balance',
    cash: 'Cash',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    bonus: 'Bonus',
    completedBonus: 'Completed Bonus',
    claim: 'Claim',
    invite: 'Invite Link',
    copy: 'Copy Link',
    cashBalance: 'Cash Balance',
    apply: 'Apply',
    depositBonus: '100% Deposit Bonus',
    agree: 'I agree with the terms and conditions',
    submit: 'Submit',
    amount: 'Amount',
    selectAmount: 'Please select an amount',
    warning: 'Please be aware you cannot withdraw your deposit without any bet after that deposit.',
    wallet: 'My Wallet',
    accountName: 'Account Name',
    accountNo: 'Account Number',
    IFSC: 'Bank Code (IFSC Code)',
    check: 'Check Agreement',
    outRange: 'Invalid amount, out of range',
    notEnough: ' enough balance available',
    copySuccess: 'Copy Success'
  },
  setting: {
    setting: 'SETTING',
    myInfo: 'MY INFO',
    mobile: 'Mobile Number',
    depositCurrency: 'Deposit Currency',
    save: 'Save',
    saveSuccess: 'Save Success',
    myHistory: 'MY HISTORY',
    status: 'status',
    system: 'System',
    event: 'Event',
    personal: 'Personal',
    logout: 'Log Out'
  },
  privacy: [
    {
      class: 't2',
      content: 'Your privacy is important to us. It is PGEbet Casino\'s policy to respect your privacy regarding any information we may collect from you across our site, https://www.pgebet.com, and other sites we own and operate.'
    },
    {
      class: 't2',
      content: 'We only ask for personal information when we truly need it to provide a service to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.'
    },
    {
      class: 't2',
      content: 'We only retain collected information for as long as necessary to provide you with your requested service. What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.'
    },
    {
      class: 't2',
      content: 'We don\'t share any personally identifying information publicly or with third-parties.'
    },
    {
      class: 't2',
      content: 'Our site may link to external sites that are not operated by us. Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.'
    },
    {
      class: 't2',
      content: 'You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.'
    },
    {
      class: 't2',
      content: 'Your continued use of our online casino/site will be regarded as acceptance of our practices around privacy and personal information. If you have any questions about how we handle user data and personal information, feel free to contact us.'
    },
    {
      class: 't2',
      content: 'This policy is effective as of 12 July 2018.'
    }
  ],
  responsible: [
    {
      class: 't2',
      content: 'At PGEbet we offer platforms and services that allow our customers to enjoy playing games and placing bets. Our goal is to provide a safe, stable environment that will give you a satisfactory and rewarding experience. We encourage our customers to use our services responsibly and in a reasonable manner.'
    },
    {
      class: 't2',
      content: 'All forms of betting have been a popular form of entertainment for many years at PGEbet. We encourage you to have fun and we only recommend it to our customers while having fun.'
    },
    {
      class: 't2',
      content: 'While most customers gamble in this manner we understand that a small number of customers can develop gambling-related problems.'
    },
    {
      class: 't2',
      content: 'At PGEbet the well-being of customers is extremely important. We take our gambling role very seriously and advise you to:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">1.&nbsp;</i>Treat your betting and gaming as a form of entertainment and use the funds you set for your entertainment only.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">2.&nbsp;</i>Do not bet or bet more than the limit that you set.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">3.&nbsp;</i>Don\'t bet with money you can\'t lose.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">4.&nbsp;</i>Don\'t chase your loss.'
    }, {
      class: 't3',
      content: '<i style="margin-left: 10px;">5.&nbsp;</i>Don\'t let your bets and/or game play prevent the use of time for other activities.'
    },
    {
      class: 't2',
      content: 'If you have concerns about gambling behaviour or feel that you are unable to follow these guidelines, we encourage you to seek advice from a certified organization that can provide support and advice.'
    },
    {
      class: 't2',
      content: 'In addition, you can contact the staff from PGEbet at Support@PGEbet.com if you wish to discuss our self-exclusion process. Please be aware that accounts that are closed under our self-exclusion policy cannot be cancelled or re-opened for any reason. However, once the self-exclusion period has expired, we will send you an email to inform you that your account is reactivated.'
    },
    {
      class: 't2',
      content: 'Underage'
    },
    {
      class: 't2',
      content: 'If you want to bet with us at PGEbet - You must be over the age of 18 or the minimum legal age for gambling in the jurisdiction in which you live. And permitted by law under the laws that apply to you.'
    }
  ],
  terms: [
    {
      class: 't2',
      content: 'The following Terms and Conditions govern the use of PGEbet Online Casino. The use of PGEbet and/or the opening of a user account is an acknowledgement that the user had read, understood and agrees to be bound by the terms and conditions of this website.'
    },
    {
      class: 't1',
      content: 'Changes to the Terms of Use'
    },
    {
      class: 't3',
      content: 'We reserve the right to make changes to the Terms of Use at any time. The Terms of Use may be changed for a number of reasons, including, but not limited to, customer service reasons, complying with applicable laws and regulatory guidance.'
    },
    {
      class: 't3',
      content: 'We recommend that you revisit and read these Terms of Use regularly, as they govern your use of the Website. We will ensure that any changes to the Terms of Use will be notified to you by an appropriate method (for example, by email or via a notice on the Website in which you need to re-confirm your acceptance of those terms) before such changes come into effect.'
    },
    {
      class: 't3',
      content: 'It is your responsibility to ensure that you agree with any changes made to the Terms of Use and your continued use of the Website will be deemed to be your acceptance of any changes that we may make.'
    },
    {
      class: 't1',
      content: 'Parties'
    },
    {
      class: 't3',
      content: 'The Terms of Use shall be agreed between you and Data Mining Global Ltd (Company). Tenancy 10, Marina House, Eden Island, Mahe, Seychelles. Trading as PGEbet Limited (\'PGEbet\').'
    },
    {
      class: 't3',
      content: 'Unless otherwise stated, \'you\', \'your\', \'user\' or \'player\' means any person who uses our software and/or the Website.'
    },
    {
      class: 't1',
      content: '1. Users\' Accounts'
    },
    {
      class: 't3',
      content: '1.1) It is the player’s responsibility to keep information such as login {email} and password confidential. PGEbet will not be held responsible for any misuse of a player’s credentials, provided that PGEbet has been correctly furnished with the account information requested. PGEbet is entitled to assume that orders, payments and instructions are made by the player.'
    },
    {
      class: 't3',
      content: '1.2) Each player is allowed to open only one User Account. Use of more than one account per physical User is known as “multi-accounting”, which is strictly prohibited. Should we discover a player with multiple accounts, all affiliated accounts associated with the player will be immediately cancelled alongside any transactions on the multiple accounts. In the event that PGEbet has reasonable grounds to suspect that the registration of said multiple accounts has been undertaken with the intent of defrauding or cheating, PGEbet may block regular or tournament play and/or prize distribution.'
    },
    {
      class: 't3',
      content: '<i/>1.2.1)You are only allowed to have one user account per household, per address, per computer and per IP address. If more than one person in your household has an account, you risk any winnings being void and being banned from the online casino. For more details please check with our Customer Support Desk via our Live Chat.'
    },
    {
      class: 't3',
      content: '<i/>1.2.2)PGEbet doesn’t allow different account users from the same household and/or family play on the same bet. In other words, this clause includes different combinations of the same bet. Should a player breach the aforementioned prohibition, PGEbet reserves the right to cancel such bet subject to the rules of cancellation stated herein.'
    },
    {
      class: 't1',
      content: '2. Deposits'
    },
    {
      class: 't3',
      content: '2.1) Funds deposited must be utilised for the placing of bets/stakes in the games and, in the interests of fair play on our site it is prohibited to utilise any recognized betting techniques/ patterns. Any suspicious activity or betting irregularities on a player’s account may lead PGEbet to freeze the funds and/or even close the account completely.'
    },
    {
      class: 't3',
      content: '2.2) Funds deposited must be wagered at least once before they can be withdrawn.'
    },
    {
      class: 't3',
      content: '2.3) In the event of misuse and/or the abuse of promotions and/or of any bonus offers from PGEbet, the online casino reserves the right to close, void any winnings and block the accounts of the client in question until the matter between PGEbet and the client is resolved.'
    },
    {
      class: 't3',
      content: '2.4) Deposits to the player account are made by transfer of money to the account by way of the payment methods located on the website.'
    },
    {
      class: 't3',
      content: '2.5) This online casino reserves the right to change the forms of payment that we may accept from time to time.'
    },
    {
      class: 't3',
      content: '2.6) You may only use payment methods registered in your own name to make deposits.'
    },
    {
      class: 't3',
      content: '2.7) We may limit your deposits on any single day.'
    },
    {
      class: 't3',
      content: '2.8) We further reserve the right to accept certain methods of payment only subject to the fulfilment of certain terms and conditions.'
    },
    {
      class: 't3',
      content: '2.9) We do not warrant that all methods of payment are available at all times.'
    },
    {
      class: 't3',
      content: '2.10) We don’t accept any cash funds sent to us.'
    },
    {
      class: 't3',
      content: '2.11) By depositing funds, you agree not to make any charge-backs, reversals or otherwise cancel any deposits into your account, and agree to refund and compensate us for unpaid deposits.'
    },
    {
      class: 't3',
      content: '2.12) We accept no responsibility for any currency exchange conversions, charges or fees levied by your card issuer, bank or financial institution.'
    },
    {
      class: 't3',
      content: '2.13) Please be advised that our products are consumed instantly when playing or betting. This means that we cannot provide returns of money, refunds or cancellation of your service when playing or betting. If you play a game or service with real money, the money will be drawn from your player account instantly.'
    },
    {
      class: 't3',
      content: '2.14) Your user account should not be used as a banking facility/account and deposits should only be made with a view to using funds to place bets. Your account is not insured, guaranteed, sponsored or otherwise by any banking insurance system nor shall it earn any interest.'
    },
    {
      class: 't3',
      content: '2.15) Should you make repeated deposits and withdrawals without commensurate bets being placed, we reserve the right to pass on to your accounts, without prior notice any bank charges we have incurred before closing the account.'
    },
    {
      class: 't3',
      content: '2.16) Payment descriptors: Your credit, debit or payment card will be billed immediately after deposits. Please contact Customer Support for queries regarding payment descriptors on your statements.'
    },
    {
      class: 't1',
      content: '3. Withdrawals'
    },
    {
      class: 't3',
      content: '3.1) The User may at any time request a pay-out from the existing balance of his/her player account in whole or in part provided that all payments have been confirmed, wagering requirements have been met, and all amounts have been deposited.'
    },
    {
      class: 't3',
      content: '3.2) Withdrawal requests are reviewed daily, from Monday to Sunday. We aim to review all withdrawal requests instantly, from the moment the user has placed a withdrawal request on their account.'
    },
    {
      class: 't3',
      content: '3.3) Players will only be able to withdraw their winnings at a sum of up to $30,000 US per week (200,000 CNY/26,500 EUR). The remaining amount will be placed back in the player\'s account until such times that they are eligible for a further withdrawal. Progressive jackpot wins are excluded from the weekly withdrawal limit.'
    },
    {
      class: 't3',
      content: '3.4) PGEbet may withhold any withdrawal in instances where you have not complied with any of the conditions management may request from the player.'
    },
    {
      class: 't3',
      content: '3.5) Should you wish to withdraw some or all of your balance you may select how much you wish to have paid back.'
    },
    {
      class: 't3',
      content: '3.6) All withdrawals will be paid back to the same payment method used to make a deposit on the account. The withdrawal methods will become available once a successful deposit is made with such a method.'
    },
    {
      class: 't3',
      content: '3.7) Where your withdrawal method is no longer valid or available (for example, it has expired) your withdrawal will not be processed, and you will be asked for details of an alternative payment method. We may request further information or documentation from you in this instance.'
    },
    {
      class: 't3',
      content: '3.8) If you have requested a withdrawal, you will receive your funds on the same day, and most of the time instantly, depending on the bank you use.'
    },
    {
      class: 't3',
      content: '3.9) The minimum withdrawal is $10 US (70 CNY/9 EUR). For INR it is minimum 1,000 INR and maximum 500,000 INR. To make a withdrawal, you must have made or make a minimum of one bet in your lifetime with us.'
    },
    {
      class: 't3',
      content: '3.10) Unless otherwise agreed in writing, the maximum you may withdraw in any week is $30,000 US (200,000 CNY/26,500 EUR) - Weekly. VIP players may be eligible for a withdrawal limit increase.'
    },
    {
      class: 't3',
      content: '3.11) You may only use payment methods registered in your own name to make withdrawals. It is your responsibility to submit the correct bank account details (where applicable) for payment of withdrawals. PGEbet cannot repay payments made by us to any other account due to incorrect account details provided by you.'
    },
    {
      class: 't3',
      content: '3.12) Funds may be deducted from withdrawals in compliance with and as required by any applicable regulation or law.'
    },
    {
      class: 't3',
      content: '3.13) As a responsible gaming operator, the max win on any given spin or bet on PGEbet is 500X the bet amount. Any win amount on a single spin exceeding 500X your bet stake will be considered a Wagered Jackpot and will be subject to 40X wagering. From time to time PGEbet management may offer players cashouts for Wagered Jackpots, however this is not a standard practice and will be dealt with on a case by case basis. A player’s main wallet balance before a Wagered Jackpot will still be eligible for withdrawal.'
    },
    {
      class: 't3',
      content: '3.14) If we mistakenly credit your account with winnings that do not belong to you, whether due to a technical error, error in the pay-tables, or human error or otherwise, the amount will remain property of us and the amount will be deducted from your account. If you have used any such amount to place wagers, we may cancel these wagers and void any winnings. If you have withdrawn funds that do not belong to you prior to us becoming aware of the error, the mistakenly paid amount will (without prejudice to other remedies and actions that may be available at law) constitute a debt owed by you to us and we may take steps to recover such amount. In the event of an incorrect crediting, you are obliged to notify us immediately by email.'
    },
    {
      class: 't3',
      content: '3.15) All transactions shall be checked in order to prevent money laundering. We shall report any suspicious transactions to the relevant authorities in the country you are based in. If you become aware of any suspicious activity relating to any of the games or anything relating to the Website, you must report this to us immediately. We may suspend, block or close an account and withhold funds if requested to do so in accordance with applicable law. Furthermore, for AML/KYC purposes, on withdrawal requests you will be asked to provide your Personal ID and Proof of Address documents, if have not already done so. This will need to be sent to Support@PGE.com and once verified you will be authorised to withdraw. If Support@PGE.com is not operational, documents are to be sent via Live Support.'
    },
    {
      class: 't3',
      content: '3.16) Enhanced due diligence may be done in respect of withdrawals of funds not used for wagering.'
    },
    {
      class: 't3',
      content: '3.17) Refunds are provided for clear errors, including clear errors showing incorrect deposits and withdrawals/payouts. Please contact our Live Support should a refund be requested.'
    },
    {
      class: 't3',
      content: '3.18) You can withdraw 8am - 4:15pm IST (Monday to Friday).'
    },
    {
      class: 't1',
      content: '4. Marketing & Promotions'
    },
    {
      class: 't3',
      content: '4.1) Bonus credits can be placed into a player’s account as part of a promotions campaign. These credits cannot be withdrawn or paid out, but they must be used for the placing of bets in the manner stated in the respective rules of different marketing bonus promotion campaigns.'
    },
    {
      class: 't3',
      content: '4.2) PGEbet reserves the right to withhold or otherwise reverse any pay-out or a winning amount or to amend any website policy in the event that there is reasonable suspicion that a player is abusing or attempting to abuse any bonuses, marketing promotions, or specific policies and terms determined in respect of existing games or new games.'
    },
    {
      class: 't3',
      content: '4.3) PGEbet retains the right to determine absolutely that such an abuse has taken place; also, if your online activity in PGEbet, by itself, is not abusive, but your activities in other online casinos in addition to our online casino, taken as a whole, constitutes abuse of our bonuses, promotions, policies or terms.'
    },
    {
      class: 't3',
      content: '4.4) Wagering requirements on bonuses are mandatory before any cash-outs will be permitted. Please note: Wagering requirements on bonuses will differ per promotion.'
    },
    {
      class: 't3',
      content: '4.5) As the required play-through requirements are met, funds can be transferred from the player’s bonus account to their cash account.'
    },
    {
      class: 't3',
      content: '4.6) Once a withdrawal request has been made you can only withdraw from your cash account. Once wagering requirements have been met for your bonus account this can be converted to your cash account.'
    },
    {
      class: 't3',
      content: '4.7) Please note: Only registered players are eligible to receive free bonuses, signup bonuses or become VIP players. And strictly no players from the US are allowed or are eligible for bonus promotions.'
    },
    {
      class: 't3',
      content: '4.8) A player may redeem only 1 (one) bonus at a time.'
    },
    {
      class: 't3',
      content: '4.9) Once the bonus has been redeemed and you have made your deposit your bonus will be automatically added to your account. The bonus will be removed from a player’s account once a withdrawal request has been made.'
    },
    {
      class: 't3',
      content: '4.10) Please be sure that you read and understand each individual bonus terms before you use any bonus to avoid misunderstandings.'
    },
    {
      class: 't3',
      content: '4.11) The bonus will expire within 7-days once it’s in your account. If you have not met the conditions of the bonus within this time-frame, any bonus amount and winnings associated with this bonus will be removed from your account.'
    },
    {
      class: 't3',
      content: '4.12) From time to time, PGEbet may offer extensive bonuses allocated to promotion campaigns which will not be available on the site, but through the campaign only.'
    },
    {
      class: 't3',
      content: '4.13) Utilization of a bonus when making a deposit shall be deemed to represent acceptance of all terms and conditions associated with the use of a promotional bonus stated above. Players are not required to use a bonus when depositing and should not do so without a complete understanding of these terms and conditions.'
    },
    {
      class: 't3',
      content: '4.14) Any free money given without requiring a deposit, e.g. a non-deposit bonus, loyalty bonus, comp points, VIP bonus, competition/tournament prizes, compensation bonus, inconvenience bonus, birthday bonus etc. (unless otherwise stated) will have a maximum cash out of $10,000 US (70,000 CNY/9,000 EUR) or 10 times the bonus amount. Minimum initial bonus wager requirements and minimum cash-in requirements apply.'
    },
    {
      class: 't3',
      content: '4.15) For security reasons, any winnings from a free bonus or winnings from a free tournament, will only be cashed in after making a minimum deposit of $10 US (70 CNY/9 EUR) in the player account.'
    },
    {
      class: 't3',
      content: '4.16) Note: All bonuses immediately exclude progressive games.'
    },
    {
      class: 't3',
      content: '4.17) If a player claims a bonus of 100% or more of their deposit, the maximum withdrawal amount will be 5 times the deposit amount after fulfilling all wagering requirements associated with the bonus credited. The remainder of the requested withdrawal will be voided. The Casino management holds the right to exercise this clause as seen appropriate.'
    },
    {
      class: 't3',
      content: '4.18) Players must open a new, real casino account at PGEbet, claim the bonus (using the assigned bonus code) within the cashier and in the case of third party promotions have been referred by our specific marketing partners that have been authorised and pre-approved to offer this exclusive bonus.'
    },
    {
      class: 't3',
      content: '4.19) The promotion free money amount is a maximum of $1,000 US (7,000 CNY/885 EUR) free, no deposit required. This amount cannot be increased or reallocated during the promotion. The maximum amount that a player can withdraw from this bonus is $2,000 US (14,000 CNY/1,770 EUR). Any additional funds will automatically be removed once the wagering requirements of the bonus have been completed.'
    },
    {
      class: 't3',
      content: '4.20) You will be required to complete the free bonus promotion wager requirement amount before being able to make a withdrawal.'
    },
    {
      class: 't3',
      content: '4.21) This bonus can only be claimed once by a player, individual or household. Any players found opening multiple accounts in order to claim this bonus will have their account frozen and any funds confiscated.'
    },
    {
      class: 't1',
      content: '5. Your Responsibilities'
    },
    {
      class: 't3',
      content: '5.1) The player is at least 18 years of age or has reached the legal age of maturity in his/her jurisdiction, whichever is greater. PGEbet Casino’s operation of Live and Virtual Casino gambling is directed only towards players who by the laws of their home jurisdiction are not prohibited from gambling on the internet through the application of the software. Some jurisdictions have not yet addressed the legality of the use of software for gambling, while some jurisdictions have specifically made internet gambling illegal.'
    },
    {
      class: 't3',
      content: '5.2) It is impossible for PGEbet to determine the state of the law in every jurisdiction around the world on an ongoing basis. Therefore, the player accepts sole responsibility for determining the laws that apply in his/her jurisdiction. The player is responsible for any consequences that may transpire as a result of his/her not determining the legality of internet gaming in his/her jurisdiction. The player understands that the player may play games free or for money. The player understands that the games are for entertainment value only and at the player’s sole decision. Commercial use of PGEbet Casino is strictly forbidden. The player will play only for private and non-professional purposes. Before placing bets, the player is responsible for verifying the laws on gambling which governs the place where PGEbet Casino is used.'
    },
    {
      class: 't3',
      content: '5.3) The player shall hold the company, its employees, officers, directors, licensees, distributors, wholesalers, affiliates, subsidiaries, advertising, promotion or other agencies, media partners, agents and retailers harmless and blameless, and shall fully indemnify the same from any and all costs, expenses, liabilities and damages whatsoever that may arise as a result of player’s:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">a.&nbsp;</i>entry, use, or reuse of the website,'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">b.&nbsp;</i>use of any materials at the website,'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">c.&nbsp;</i>entry, use, or reuse of the casino server,'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">d.&nbsp;</i>participation in the game/s, or,'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">e.&nbsp;</i>the acceptance of any prize.'
    },
    {
      class: 't3',
      content: '5.4) Players shall periodically review at a rate not less than once monthly these Terms and Conditions posted on this Website.'
    },
    {
      class: 't3',
      content: '5.5) The player shall not participate in the games, open, use or reuse an account, enter the Website, or the casino, nor accept any prize if player does not fully understand, agree to, become a party to, and shall abide by, without exception, all rules, regulations, terms and conditions contained herein and as such rules, regulations, terms and conditions may change periodically.'
    },
    {
      class: 't3',
      content: '5.6) The player is obliged to keep his/her private username and password secret and confidential. Any use of the software application through the player’s username is the sole responsibility of the player.'
    },
    {
      class: 't3',
      content: '5.7) The player will not allow any third party or person, including and without limitation to any minor, to use his/her account to place wagers or participate in the games in any way. The player is fully responsible for any taxes and fees applicable to winnings resulting from use of the software.'
    },
    {
      class: 't3',
      content: '5.8) If winnings are taxable in the player’s jurisdiction, the player is required to keep track and report the winnings to the appropriate authorities. Personal identity and details of all members will remain confidential. PGEbet Casino will not report wagering information on behalf of any user.'
    },
    {
      class: 't3',
      content: '5.9) PGEbet reserves the right to cancel your membership at any time without notice. Any balance in your account will be immediately credited back to your credit card or payment card. In addition, PGEbet reserves the right, in its total discretion, to void any winnings and withhold any balance in your PGEbet casino account under any of the following circumstances:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">a.&nbsp;</i>If the name on the PGEbet Casino account does not match the name on the payment/credit card(s) used to deposit money into the account.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">b.&nbsp;</i>If you provide false and or misleading information used to open a PGEbet account.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">c.&nbsp;</i>If you are not of legal age in the jurisdiction where you reside.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">d.&nbsp;</i>If you reside in a jurisdiction, where law prohibits the use and participation of such games.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">e.&nbsp;</i>If you have allowed or permitted (purposely or not) another party to play on your PGEbet Casino account.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">f.&nbsp;</i>If you have reversed or charged back any of your purchases on the PGEbet Casino account.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">g.&nbsp;</i>You are allowed only one account per household, computer and workplace. Winnings will only be paid to players having one account. If you have more than one account, all winnings and bonuses will be void.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">h.&nbsp;</i>If you are found cheating or if it is determined by PGEbet that you have used a system, strategy or machine, be it an additional computer, additional software, using a Martingale betting system or any other system used to circumvent the natural randomness of our systems.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">i.&nbsp;</i>The name on the casino account does not match the name of the beneficial owner of the financial instrument used to make the deposit or withdrawal.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">j.&nbsp;</i>If your financial information, personal information or gaming modus operandi is similar to known fraudsters or deemed to be high risk or abusive by our security team.'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">k.&nbsp;</i>If you do not log onto your casino account for a period of 90 days, any balance in your account will be forfeited to the Company (PGEbet).'
    },
    {
      class: 't1',
      content: '6. VIP Members\' Club'
    },
    {
      class: 't3',
      content: '6.1) PGEbet Online Casino reserves the right to change the Terms and Conditions and rules for the Loyalty Rewards Program at any time, For example: changing the parameters for calculations of points. If PGEbet suspects that a user is engaged in illegal or fraudulent activities when using the Rewards and/or VIP Loyalty Rewards Program or is in breach of these Terms and Conditions, PGEbet may freeze or terminate your account at PGEbet’s absolute discretion.'
    },
    {
      class: 't3',
      content: '6.2) Once You have registered, you will automatically become a member of the PGEbet Loyalty Rewards and VIP Members Club. When playing for real money you will increase your VIP status and have the chance to earn special rewards. Please view our Promotions Page for more details on current VIP Member Club promotions.'
    },
    {
      class: 't1',
      content: '7. Live Support'
    },
    {
      class: 't3',
      content: 'We provide users with a live chat facility to enable you to communicate with our Customer Support Team. We may review and keep a record of all such content on our chat facility. We reserve the right to remove or amend this chat facility at our sole discretion.'
    },
    {
      class: 't1',
      content: '8. Cashback Bonuses'
    },
    {
      class: 't3',
      content: 'To qualify, there is no opt-in required. Weekly Cash Back Bonuses may be available to players from time to time. To qualify for your cashback bonus, we have a few rules that need to be adhered to.'
    },
    {
      class: 't3',
      content: '8.1) Receive 10% cashback of your weekly net loss (if any).'
    },
    {
      class: 't3',
      content: '8.2) Your available balance needs to be under $100 US (700 CNY/90 EUR) to qualify.'
    },
    {
      class: 't3',
      content: '8.3) You should have no pending withdrawals on the system.'
    },
    {
      class: 't3',
      content: '8.4) This offer is only available to players who have deposited $200 US (700 CNY/90 EUR) or more in the previous week.'
    },
    {
      class: 't3',
      content: 'Please note: Cashback Allocations are automatically allocated Mondays at 10:00am HK time.'
    },
    {
      class: 't1',
      content: '9. Bonus and Free Spin Promotions'
    },
    {
      class: 't3',
      content: '9.1) Free Spins are not real money. Free Spins are considered as a bonus and are subject to the bonus wagering and all other bonus terms.'
    },
    {
      class: 't3',
      content: '9.2) The money won from Free Spins will be credited to your bonus amount balance and is subject to our standard terms and conditions, bonus terms and wagering requirements. However, winnings after wager requirements are completed are real money and are available for withdrawal.'
    },
    {
      class: 't3',
      content: '9.3) Wagering requirements on bonuses will differ per promotion.'
    },
    {
      class: 't3',
      content: '9.4) When wagering, funds on the main user account will be used prior to the use of bonus money.'
    },
    {
      class: 't3',
      content: '9.5) Bonus money or free spins can only be received once per account/person/household/IP address during a promotional period unless otherwise stated.'
    },
    {
      class: 't3',
      content: '9.6) To request a withdrawal, you must wager a minimum of 40 times the bonus amount, unless otherwise stated in the promotion.'
    },
    {
      class: 't3',
      content: '9.7) The bonuses we offer have a limited validity period of 7 days, unless bonus rules state otherwise. A customer must meet the play requirements before the expiration date of the bonus, otherwise, the bonus, or a combination of the bonus along with the winning amounts sourced on said bonus will be removed from the player’s account once the bonus expires.'
    },
    {
      class: 't3',
      content: '9.8) Reversed withdrawals are not considered deposits and will not be matched with a bonus.'
    },
    {
      class: 't3',
      content: '9.9) Wagering on all games at our casino contributes towards the wagering requirement but certain games contribute greater amounts than others.'
    },
    {
      class: 't3',
      content: '9.10) After being awarded a deposit bonus, a user’s bonus balance will reflect in their bonus wallet. Only after a user completes the relevant wagering requirement, or alternatively “opt out” from wagering requirement, will the bonus balance be transferred to the main wallet of the player.'
    },
    {
      class: 't3',
      content: '9.11) All users who have used a deposit bonus that is subject to wagering, will have the option to opt out at any point in time during wagering play. To “opt out” means a user no longer wishes to be subject to wagering and the amount transferred to a user’s main wallet will be the % of wagering completed bonus balance at the time of opting out. For example - If a user deposited $1000 with 100% deposit bonus, their Bonus wallet will reflect $2000 balance with a "40X" amount Wagering requirement. If a user then completes 25% of their wagering requirement and their bonus balance at the time is $12,000 - the user then has the option to “opt out”, whereby 25% (the amount of wagering completed) of the $12,000 Bonus Balance (which is $3000), will automatically be transferred to the user’s main wallets balance and be eligible to withdraw.'
    },
    {
      class: 't3',
      content: '9.12) Bonus money amounts cannot form the subject of a request for withdrawing as cash. A player cannot withdraw any winnings from a bonus balance until all the requirements are met for the named bonus.'
    },
    {
      class: 't3',
      content: '9.13) As the wagering requirements are met, funds are automatically transferred from the bonus balance to the cash balance.'
    },
    {
      class: 't3',
      content: '9.14) If we believe that a customer was not included in a particular bonus promotion, the bonuses shall not be awarded and no subsequent payouts shall be honoured. We reserve the right to deny promotion participation without further explanation.'
    },
    {
      class: 't3',
      content: '9.15) PGEbet may, at its sole discretion, change the terms and conditions, or limit the eligibility of players to participate in this promotion, for any reason whatsoever without prior notice to the end users.'
    },
    {
      class: 't3',
      content: '9.16) Bonuses offered by our Casino are intended for genuine recreational players only. Abuse of any bonus offer will not be tolerated. We reserve the right to investigate, cancel, suspend or lock any account if bonus abuse is suspected. At our discretion, all bonuses and subsequent gaming activity may be revoked and voided, and deposits returned.'
    },
    {
      class: 't3',
      content: '9.17) Should PGEbet suspect that a player has committed bonus abuse, either on his own, or in association with partners, PGEbet reserves the right to forfeit the bonus and void any winnings.'
    },
    {
      class: 't1',
      content: '10. Indemnity'
    },
    {
      class: 't3',
      content: 'You further agree to fully indemnify, defend and hold us and our officers, directors, employees, agents, contractors and suppliers harmless, from and against all claims, liabilities, damages, losses, costs and expenses, including legal fees, arising out of any breach of this Agreement by you, and any other liabilities arising out of your use of the PGEbet Online Casino or the associated software.'
    },
    {
      class: 't1',
      content: '11. Security'
    },
    {
      class: 't3',
      content: 'You will not break in, access, attempt to break in or otherwise by-pass our security. If we have a suspicion that you have attempted to or may be attempting to break in, access or otherwise by-pass our security or the software, we will be entitled to terminate with immediate effect your access to the PGEbet Casino and/or have your account blocked, and we reserve the right to inform the applicable authorities.'
    },
    {
      class: 't3',
      content: '11.1) You acknowledge that our random number generator will determine the outcome of the games played on the PGEbet Casino and you accept the outcomes of all such games. You further agree that in the unlikely event of a disagreement between the result that appears on the software and the game server, the result that appears on the game server will prevail. You acknowledge and agree that our records will be the final authority in determining the terms and circumstances of your participation in the Online Casino gaming activity.'
    },
    {
      class: 't3',
      content: '11.2) You will not commit any acts or display any conduct that damages our reputation or any other related service providers.'
    },
    {
      class: 't1',
      content: '12. Legal Requirements'
    },
    {
      class: 't3',
      content: 'PGEbet Casino is restricted to individuals who are over the age of Legal Majority who are residents of jurisdictions (“Player/Players”) where the use of PGEbet Casino and its games are not prohibited by law. All PGEbet Casino games are void and should not be accessed where prohibited by law. Minors are strictly forbidden to play.'
    },
    {
      class: 't1',
      content: '13. Use of Software'
    },
    {
      class: 't3',
      content: 'PGEbet Casino hereby grants the player a personal, non-exclusive, non-transferable sub-license to use the software for playing in the Online Casino.'
    },
    {
      class: 't3',
      content: 'PGEbet Casino uses advanced encryption systems to protect the user name and password information, and any other delicate information transferred to and from the client application and PGEbet Casino servers, thus protecting the player and the Casino against attempts of manipulation by a third party.'
    },
    {
      class: 't1',
      content: '14. Arbitrator/Arbitration'
    },
    {
      class: 't3',
      content: '14.1) PGEbet will act as the final arbitrator or any dispute involving PGEbet Casino and any other party. PGEbet reserves the right to employ an arbitrator of its choice to act as an agent of arbitration in place of PGEbet in the event of a dispute.'
    },
    {
      class: 't3',
      content: '14.2) All disputes should be forwarded to PGEbet Casino by email within one (1) hour of the disputed event. PGEbet Casino will answer all customers within 2 business days. In the event of a dispute, all decisions made by the casino will be final.'
    },
    {
      class: 't3',
      content: '14.3) Should any slot game be at any time interrupted and/or disconnected, the situation at the point of interruption and results from the previous game should be displayed when the player starts the game again. If the player becomes disconnected from PGEbet’s Live Table games server mid-game, the bet will be forfeited and the player’s last bet will not be refunded, due to the live nature of our Live Casino situated in Latvia. This however, should never occur.'
    },
    {
      class: 't3',
      content: '14.4) PGEbet Casino makes every effort to ensure the full protection of its customers. However, certain unforeseen events are beyond the control of PGEbet. In the event of a disconnection for any reason whatsoever between the player and the Casino, PGEbet shall not be held liable for any losses which may result therefrom. The balance of a player’s account shall at all times be as recorded on the PGEbet Casino server.'
    },
    {
      class: 't1',
      content: '15. Payments'
    },
    {
      class: 't3',
      content: '15.1) Before any withdrawals are processed, your play will be reviewed for any irregular playing patterns. In the interests of fair gaming, equal, zero or low margin bets or hedge betting, shall all be considered irregular gaming for bonus play-through requirement purposes. Other examples of irregular game play include but are not limited to, placing single bets equal to or in excess of 30% or more of the value of the bonus credited to their account until such time as the wagering requirements for that bonus have been met. Should the Casino deem that irregular game play has occurred, PGEbet reserves the right to withhold any withdrawals and/or confiscate all winnings.'
    },
    {
      class: 't3',
      content: '15.2) In addition to the above, when processing withdrawals, if the accumulated deposits of a player do not exceed $5,000 US (35,000 CNY/4,400 EUR) , the player is only entitled to a maximum amount of 10 x this amount in a withdrawal request (based on his winnings). Example: accumulated deposits $200, winnings $2500, withdrawal request $2500, effective payment $2000 only, $500 is reduced from the player’s balance. Please also note, we reserve the right to pay your withdrawal to the payment method most convenient to the Casino.'
    },
    {
      class: 't3',
      content: '15.3) PGEbet Casino will use its reasonable endeavors to release player’s funds using their preferred method. However, where necessary to comply with local laws, regulations and to ensure both parties’ security, PGEbet Casino reserves the right to release a player’s winnings using the most appropriate payment method determined at PGEbet’s absolute discretion.'
    },
    {
      class: 't3',
      content: '15.4) Any deposit made into your Casino account is an indication to the Casino of your intention to wager at the Casino. Failing to do so, may result in all deposit credits being withheld for further investigation. Under such circumstances, the PGEbet Casino further has the right to remove processing fees at any time without player notification.'
    },
    {
      class: 't3',
      content: '15.5) Making deposits and then cashing-out without wagering will not be tolerated. The Casino has the discretion not to allow the cash-out to be processed. The Casino’s decision is final.'
    },
    {
      class: 't3',
      content: '15.6) PGEbet Casino reserves the right to request an Authorization Form at any time and may terminate any account that does not satisfactorily complete and/or return the Authorization Form in a time period determined as reasonable by PGEbet Casino. In such a case, PGEbet Casino may unilaterally determine the resolution of any account funds.'
    },
    {
      class: 't3',
      content: '15.7) In cases of fraudulent documentation (where required), account will be locked and all winnings and/or cash-outs will be void.'
    },
    {
      class: 't3',
      content: '15.8) All cash-outs will be subject to audit before being processed. You will be notified by email when we send out your winnings. Withdrawals and changes to payment instructions are subject to clearance by our Security Department. PGEbet Casino reserves the right to pay out higher winnings over a period of several weeks in installments.'
    },
    {
      class: 't3',
      content: '15.9) When a bonus is redeemed, wagering on restricted games is forbidden. Doing so will void any winnings. PGEbet Casino reserves the right to withhold any amount in excess of the player’s original deposit from a player’s withdrawal if the play bonus is wagered on restricted games. Different bonuses have different restricted games, and it is the player’s responsibility to review each and every bonus’ specific terms and conditions, for the restricted games list.'
    },
    {
      class: 't3',
      content: '15.10) PGEbet Casino reserves the right to refuse or rescind the play bonus for any reason including, but not restricted to, player abuse. In case of abuse, PGEbet Casino reserves the right to discontinue player’s membership and to prevent the player from accessing PGEbet Casino in the future.'
    },
    {
      class: 't3',
      content: '15.11) Bonuses will be credited on deposits only. Reversed withdrawals are not considered deposits and will not be matched with a bonus.'
    },
    {
      class: 't3',
      content: '15.12) If any of a player’s real money deposits to the Casino are reversed due to insufficient funds, chargeback, or any other reason, irrespective of the payment method, the Casino withholds the right to cancel any bonuses, credits, wins or withdrawals. Play bonuses will be given only once per household and/or per account, as per our terms of use. If a second account is opened it will be closed and all play bonuses, deposits and winnings may be cancelled.'
    },
    {
      class: 't3',
      content: '15.13) The Player is fully aware of the fact that his payment/credit card, when used for deposit/purchase will be immediately billed after deposit/purchase. All BONUS credits are for wagering purposes only. (No withdrawal will be honoured for an amount less than the BONUS.) Upon a withdrawal request (regardless of the number of deposits), any amount up to the equivalent value of the PLAY BONUS will be deducted from your play balance or winnings prior to settlement. The first credits wagered will be deducted from your deposit(s) rather than from the PLAY BONUS.'
    },
    {
      class: 't3',
      content: '15.14) You agree that we or a payment processing company (“Payment Processor”) on our behalf will handle all financial account transactions. You hereby agree that the Payment Processor reserves the right to withhold any payments should the Payment Processor have reason to believe or any suspicion that you may be engaging in or have engaged in fraudulent, collusion, unlawful, or improper activity.'
    },
    {
      class: 't3',
      content: '15.15) You agree to fully pay any and all payments due to us or any third party in connection with your use of the Online Casino. You further agree not to make any charge-backs and/or renounce or cancel or otherwise reverse any of your due payments and in any such event you will refund and compensate us for such unpaid payments including any expenses incurred by us in the process of collecting your payment.'
    },
    {
      class: 't3',
      content: '15.16) We promise to answer all queries within 1 working day from time of receipt, additional to the live chat function during operating hours.'
    },
    {
      class: 't3',
      content: '15.17) You can only use the Online Casino and/or the Website if you are the legal age as determined by the law of the country where you live.'
    },
    {
      class: 't3',
      content: '15.18) Please note: You cannot use the Online Casino and/or the Website if you are under 18 years of age in any circumstances.'
    },
    {
      class: 't3',
      content: '15.19) Please note: Some legal jurisdictions have not addressed the legality of online gambling and others have specifically made online gambling illegal. We do not intend that anyone should use the Online Casino and/or the Website where such use is illegal. The availability of the Online Casino and/or the Website does not construe an offer or invitation by us to use the Online Casino in any country in which such use is illegal. You accept sole responsibility for determining whether your use of the Online Casino is legal in the country where you live.'
    },
    {
      class: 't1',
      content: '16. Refer A Friend'
    },
    {
      class: 't3',
      content: 'Refer-a-Friend Program – TBD, please check back soon.'
    },
    {
      class: 't1',
      content: '17. Closing Your Account'
    },
    {
      class: 't3',
      content: '17.1) PGEbet is not at liberty to close players’ user accounts.'
    },
    {
      class: 't3',
      content: '17.2) We reserve the right to close your account at any time for any reason. If we terminate your account for any reason the provisions set out below shall apply:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>You agree that we shall not be liable to you for any termination of your account or your use of the Website;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Your sole remedy in the event of termination of your account shall be the reimbursement of any undisputed account balance you may then have and we shall have no further liability to you whatsoever;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>Where we terminate your account due to you breaching any of these Terms of Use, we have the unfettered discretion to void any winnings and confiscate any balance. Such breaches include, but are not limited to:'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If you have more than one active account (or control more than one active account);'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>You are in breach or any of your warranties;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If you have opened an account having previously been banned from opening any further accounts within our network;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>We are required to do so pursuant to any legal and regulatory obligations;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If the name on your account does not match the name on the payment method used to make deposits;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If you provide incorrect or misleading registration information;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If you have allowed or permitted (intentionally or unintentionally) someone else to play on your account;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If you have "charged back" any of the deposits made with your payment/credit card on your account;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If you are found colluding, cheating, money laundering or undertaking fraudulent activity;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If it is determined by us that you have employed or made use of a system (including machines, computers, software or other automated systems) designed specifically to defeat the Casino;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If you make statements that are sexually explicit or offensive in the chat facility or to any of our staff members, including expressions of bigotry, racism, hatred or profanity;'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>The use of robotic, mechanical, electronic, or other devices to automatically make playing decisions in any game (without our explicit consent); or'
    },
    {
      class: 't3',
      content: '<i style="margin-left: 10px;">●&nbsp;</i>If we should become aware that you have played at any other Online Casino in bad faith or under any of the circumstances set out above.'
    },
    {
      class: 't3',
      content: '17.3) Upon termination of your account, you agree and acknowledge that your rights to use the Online Casino shall immediately terminate and you will remove any software provided to you or downloaded from the Website.'
    },
    {
      class: 't1',
      content: '18. Fraud'
    },
    {
      class: 't3',
      content: '18.1) We reserve the right to withhold payment to you where you are suspected of engaging in fraudulent, dishonest or criminal activities.'
    },
    {
      class: 't3',
      content: '18.2) You shall indemnify and shall be liable to pay us, on demand, all costs, charges or losses sustained or incurred by us (including any direct, indirect or consequential losses, loss of profit and loss of reputation) arising directly or indirectly from your fraud, dishonesty or criminal actions.'
    },
    {
      class: 't1',
      content: '19. Complaints and Disputes'
    },
    {
      class: 't3',
      content: '19.1) Any escalation of a customer enquiry to the Complaints Team will be classified as a "Complaint". Please note that any calls to our Customer Support Team or to our managers/supervisors may be monitored or recorded for training and quality management purposes and to assist us in the quick and effective resolution of customer queries.'
    },
    {
      class: 't3',
      content: '19.1) Any escalation of a customer enquiry to the Complaints Team will be classified as a "Complaint". Please note that any calls to our Customer Support Team or to our managers/supervisors may be monitored or recorded for training and quality management purposes and to assist us in the quick and effective resolution of customer queries.'
    },
    {
      class: 't3',
      content: '19.1) Any escalation of a customer enquiry to the Complaints Team will be classified as a "Complaint". Please note that any calls to our Customer Support Team or to our managers/supervisors may be monitored or recorded for training and quality management purposes and to assist us in the quick and effective resolution of customer queries.'
    }
  ],
  news: {
    readMore: '阅读详情'
  },
  about: [
    {
      class: 't2',
      content: 'We pride ourselves on being one of the most popular Online Casinos in the world. We are more proud of our aim to be the most trusted and secure Online Casino, to provide the ultimate in gaming entertainment to our 5,000,000+ users. Our games are fun, exciting and truly immersive. It’s just like being on the floor of a real life Casino!'
    },
    {
      class: 't1',
      content: '<i>Fair, Safe and Secure</i>'
    },
    {
      class: 't2',
      content: 'When you play at PGEbet, you’re guaranteed a fair, safe and secure Online Casino environment.'
    },
    {
      class: 't2',
      content: 'Staffed by attentive and knowledgeable experts, our Customer Support Team is here to ensure your time with us is hassle-free and as enjoyable as possible. We’re available 365 days a year.'
    },
    {
      class: 't2',
      content: 'So discover the ultimate experience in online gaming entertainment. We’re confident that PGEbet will be your favourite place to bet online.'
    }
  ],
  faqList: [
    {
      key: 'common',
      label: 'Most Common Questions'
    },
    {
      key: 'account',
      label: 'Account'
    },
    {
      key: 'bonus',
      label: 'Bonus And Promotions'
    },
    {
      key: 'deposit',
      label: 'Deposits'
    },
    {
      key: 'withdraw',
      label: 'Withdrawals'
    },
    {
      key: 'wagering',
      label: 'Wagering Requirements'
    },
    {
      key: 'support',
      label: 'Technical Support'
    }
  ],
  faqDetailList: {
    common: [
      {
        subTitle: 'How do I make a deposit?',
        content:
          '<div style="margin-bottom: 10px;">Log in to your account and complete the following steps:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Click on the "DEPOSIT" button at the top right-hand corner next to your account profile</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Enter deposit amount</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Click "SUBMIT"</div>' +
          '<div style="margin-top: 10px;">Then start playing your favourite games.</div>'
      },
      {
        subTitle: 'What is the lowest amount that I can deposit?',
        content: '<div>The minimum deposit amount is $10 US (70 CNY/9 EUR). For INR it is minimum 200 INR and maximum 10,000 INR per transaction.</div>'
      },
      {
        subTitle: 'How does 3D Secure work?',
        content:
          '<div>Before a deposit can be made, the system authenticates the cardholder by redirecting the cardholder to the browser of the bank that issued the card.</div>' +
          '<div style="margin-top: 10px;">When you make an online transaction with 3D Secure, you are redirected to a webpage from your card issuer, which asks you to enter your PIN or password.</div>'
      },
      {
        subTitle: 'How quickly will my deposit be credited to my account?',
        content:
          '<div>The processing time is instant.</div>'
      },
      {
        subTitle: 'My deposit was not credited to my account?',
        content:
          '<div>The first thing to do is to refresh your page. If the deposited amount is still not credited, please contact our LiveSupport team, and one of our representatives will be able to help you.</div>' +
          '<div style="margin: 10px 0;">Please be prepared to provide the following information:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Which deposit method did you use?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>When did you make the deposit?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>What amount was the deposit?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>What bank are you with?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>Have the funds been withdrawn from the account you made your deposit from? If so, please provide a screenshot of the transaction/bank statement.</div>'
      },
      {
        subTitle: 'Where can I find my deposit history?',
        content:
          '<div>To view this information, simply click on the "Account" Link on the top right hand corner next to your account profile, then select "History" to view all your past deposits made.</div>'
      }
    ],
    account: [
      {
        subTitle: 'How do I create an Account?',
        content:
          '<div>To register and create an account, click on the "LOGIN" button located on the top right hand side of your screen; fill in your details; once completed, click on "SUBMIT" to complete sign up.</div>'
      },
      {
        subTitle: 'What do I do if I have forgotten my password?',
        content:
          '<div>If you have forgotten your password you have signed up with, click on "LOGIN" on the top right hand side of the screen, select "forgot password", and enter your email address. You will receive an email to reset your password. If it didn\'t reach your Inbox, please check your junk and spam folders.</div>' +
          '<div style="margin-top: 10px;">If your username and password are correct and you still cannot login to your account, try clearing your browser\'s cache & cookies and refresh the page. Alternatively, please reach out to our Live Support on our live chat.</div>'
      },
      {
        subTitle: 'I am unable to create a new account, because an account has already been created from this device, what do I do?',
        content:
          '<div>Ensure that you don\'t already have an account with us. Keep in mind that we only allow one account per player. If you have created an account with us in the past, we kindly ask you to play on your existing account.</div>' +
          '<div style="margin-top: 10px;">If you cannot remember your login details, please follow the password recovery instructions. If you have never signed up for an account, but your account credentials already exist in our database please contact our Live Support team so we can investigate further.</div>'
      },
      {
        subTitle: 'Where do I see my balance?',
        content:
          '<div>You will find your balance on the top right hand side of the screen, next to the "DEPOSIT" button and your account profile.</div>'
      },
      {
        subTitle: 'How can I keep my account secure?',
        content:
          '<div>Password protection is your responsibility. Never reveal your account information to anyone.</div>' +
          '<div style="margin-top: 10px;">We will never ask you to send your password to us, and the only time you will need to use it is when logging in to the website. We recommend that you change your password regularly.</div>'
      },
      {
        subTitle: 'How do I reopen my account?',
        content:
          '<div>If you decide to come back to PGEbet, all you need to do is chat to our Live Support and they will submit your request to have your account reopened for you, no questions asked.</div>'
      }
    ],
    bonus: [
      {
        subTitle: 'Where can I see current bonuses and promotions available to me?',
        content:
          '<div>You can find all current promotions on the Promotions page. Occasionally, we send out notifications when we have a promotion for you to take part in. You also have the option to opt out of these notifications should you not want to receive them any longer.</div>'
      },
      {
        subTitle: 'How do bonuses work and what is the 100% Deposit Bonus?',
        content:
          '<div>PGEbet offers a variety of bonuses that can be awarded to your account. Bonus allocations are incentives awarded to you based on activity on our website. Occasionally we will send you bonus promotions which may include deposit bonuses and other game promotions.</div>' +
          '<div style="margin-top: 10px;">Currently we offer a 100% Deposit Bonus. This means that a $100 deposit would get an additional $100 in bonus money, creating a player balance of $200. Please note the user will then be subject to wagering requirements.</div>'
      },
      {
        subTitle: 'How do I claim my bonus?',
        content:
          '<div>To find your bonus, click on the "Account" link located on the top right hand side, and in the menu that opens, your bonus amount will automatically be shown. Select CLAIM once you have completed your wagering requirement so you can convert the bonus amount to your Cash Account.</div>'
      },
      {
        subTitle: 'How will I know my rank in a tournament?',
        content:
          '<div>Each tournament has a leaderboard that is constantly updated. To view a leaderboard for a tournament, click on the Promotions page, and select the tournament you are participating in.</div>'
      },
      {
        subTitle: 'How do I receive my tournament prize?',
        content:
          '<div>Prizes are typically credited the following business day, after the end of the promotion time frame. However pending further reviews, it may take up to three business days.</div>' +
          '<div style="margin-top: 10px;">Should you not have received a reward three business days after a promotion has finished, please contact our Live Support, and one of our representatives will be able to help.</div>'
      },
      {
        subTitle: 'How do I win a Casino tournament?',
        content:
          '<div>Each tournament has several participation conditions. To check the conditions, go to the Promotions page, and view the tournament you would like to participate in.</div>'
      },
      {
        subTitle: 'What are cash back bonuses?',
        content:
          '<div>Cashback bonuses are a monetary reward representing a certain amount of the deposit money that has been put into the games, which you can claim back in your wallet, without a wagering requirement.</div>'
      },
      {
        subTitle: 'How do free spins work?',
        content:
          '<div>Let\'s say you are awarded 50 free spins. That way you have the possibility to play 50 spins on the featured games without needing any actual money in your account balance.</div>' +
          '<div style="margin-top: 10px;">In case of any winnings generated from free spins, they will be credited to your account as bonus money and will be subject to our standard terms and conditions, bonus terms and wagering requirements. However, once the wager requirements or play-through requirements are completed, the winnings are considered real money and are available for withdrawal.</div>'
      },
      {
        subTitle: 'Does a bonus expire?',
        content:
          '<div>Bonuses are valid for seven (7) days, so any current wagering requirements must be completed within that time frame; otherwise the bonus balance will be voided.</div>'
      }
    ],
    deposit: [
      {
        subTitle: 'How do I make a deposit?',
        content:
          '<div style="margin-bottom: 10px;">Log in to your account and complete the following steps:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Click on the "DEPOSIT" button at the top right-hand corner next to your account profile</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Enter deposit amount</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Click "SUBMIT"</div>' +
          '<div style="margin-top: 10px;">Then start playing your favourite games.</div>'
      },
      {
        subTitle: 'What is the lowest amount that I can deposit?',
        content: '<div>The minimum deposit amount is $10 US (70 CNY/9 EUR). For INR it is minimum 200 INR and maximum 10,000 INR per transaction.</div>'
      },
      {
        subTitle: 'How does 3D Secure work?',
        content:
          '<div>Before a deposit can be made, the system authenticates the cardholder by redirecting the cardholder to the browser of the bank that issued the card.</div>' +
          '<div style="margin-top: 10px;">When you make an online transaction with 3D Secure, you are redirected to a webpage from your card issuer, which asks you to enter your PIN or password.</div>'
      },
      {
        subTitle: 'How quickly will my deposit be credited to my account?',
        content:
          '<div>The processing time is instant.</div>'
      },
      {
        subTitle: 'My deposit was not credited to my account?',
        content:
          '<div>The first thing to do is to refresh your page. If the deposited amount is still not credited, please contact our LiveSupport team, and one of our representatives will be able to help you.</div>' +
          '<div style="margin: 10px 0;">Please be prepared to provide the following information:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Which deposit method did you use?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>When did you make the deposit?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>What amount was the deposit?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>What bank are you with?</div>' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>Have the funds been withdrawn from the account you made your deposit from? If so, please provide a screenshot of the transaction/bank statement.</div>'
      },
      {
        subTitle: 'Where can I find my deposit history?',
        content:
          '<div>To view this information, simply click on the "Account" Link on the top right hand corner next to your account profile, then select "History" to view all your past deposits made.</div>'
      }
    ],
    withdraw: [
      {
        subTitle: 'Can I withdraw my bonus balance?',
        content:
          '<div>The bonus balance cannot be withdrawn if the wagering requirements have not yet been met.</div>'
      },
      {
        subTitle: 'How do I make a withdrawal?',
        content:
          '<div>To make a withdrawal request, click on the "Account" link located on the top right hand side; Click on "WITHDRAW" and enter your banking details.</div>'
      },
      {
        subTitle: 'How much can I withdraw?',
        content:
          '<div>Maximum withdrawal limit is $30,000 US (200,000 CNY/26,500 EUR/2M INR) per week; which also depends on a user’s VIP status and player profile. For INR it is maximum 500,000 INR at a time. In some cases we may review a player’s account and increase the weekly withdrawal limit based on their player activity, deposit values etc. This will be at the sole discretion of PGEbet management.</div>'
      },
      {
        subTitle: 'What is the minimum amount I can withdraw?',
        content:
          '<div>The minimum withdrawal amount is $10 US (70 CNY/9 EUR). For INR it is minimum 10 INR and maximum 100,000 INR per transaction.</div>'
      },
      {
        subTitle: 'When can I withdraw?',
        content:
          '<div>You can withdraw 9am - 5pm IST (Monday to Friday). If you would like to withdraw after these hours please contact Support.</div>'
      }
    ],
    wagering: [
      {
        subTitle: 'What is a wagering requirement?',
        content:
          '<div>Wagering requirement as it is often referred to is the value amount you need to bet in order for your bonus balance to convert to real money credit and become eligible to withdraw. For example: If a player deposits $1,000 with a 100% Bonus Coupon and that bonus has a 40X wagering, that would be that the your bonus balance credited to your account ($1,000) will need to be wagered or played 40X (40 times) your bonus balance amount.</div>' +
          '<div style="margin-top: 10px;">$1,000 Deposit on a 100% Deposit Bonus Coupon = $1,000</div>' +
          '<div style="margin-top: 10px;">In this example, $1,000 X 40 is your wagering requirement = $40,000</div>' +
          '<div style="margin-top: 10px;">Once you have played 40X your bonus balance ($40,000 worth of bets/spins), your bonus funds will convert to your main wallet and you are eligible to withdraw your funds.</div>' +
          '<div style="margin-top: 10px;">For more info, view our terms and conditions page.</div>'
      },
      {
        subTitle: 'Can I cancel or opt out from wagering?',
        content:
          '<div>You cannot cancel your wagering once activated, however at PGEbet we have ensured that players are able to "opt out" from wagering and convert their bonus balance to their main wallet balance.</div>'
      },
      {
        subTitle: 'What happens when I opt out from wagering?',
        content:
          '<div>On the "Account" page you are able to track your wagering requirement in real time. There will be a % of wagering completed if you have played already. That percentage of wagering completion is the % of real money that will convert to your main wallet when you opt out.</div>'
      }
    ],
    support: [
      {
        subTitle: 'What happens if the game freezes in the middle of a round?',
        content:
          '<div>Should your game freeze at any point in time, you will end up exactly where you left off next time you open the game. If there is no option for you to do so, the round will be completed on the server even if your computer is frozen or the Internet connection stopped working. Any winnings are paid out to your account as usual.</div>'
      },
      {
        subTitle: 'Why are the games running slow?',
        content:
          '<div>Make sure you have the latest version of your browser installed (we recommend Google Chrome) and the latest version of Flash. Also make sure that it is not the Internet connection that is the problem (try to play with the network cable if the wireless connection is not working like it should) and close any background programs that might drain your bandwidth.</div>'
      },
      {
        subTitle: 'Why aren’t my games loading?',
        content:
          '<div>This may mean that you have lost contact with the server. Try to log out and log back in and try again. Sometimes you may need to shut down the browser and start over for the game to load. If the problem persists, please reach out to our LiveSupport team and one of our representatives will be able to help.</div>'
      },
      {
        subTitle: 'What do I do if I cannot open a game?',
        content:
          '<div>If you receive an error message when trying to open a game, contact our LiveSupport team and one of our representatives will be able to help you.</div>'
      },
      {
        subTitle: 'How can I test the games?',
        content:
          '<div>If you want to just test the games without claiming any free chips and without changing your current balance, you can log in, choose a game you would like to try out and click on the “TRY” button available on the featured games.</div>'
      },
      {
        subTitle: 'How do I clear Cache & Cookies?',
        content:
          '<div>Here are some examples:</div>' +
          '<div style="margin: 10px 0;">Google Chrome:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Click Chrome menu on the browser toolbar;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Select Tools;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Select Clear browsing data;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>Use checkboxes to select "Cookies and other site and plug-in data" and "Cached images and files";</div>' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>Click "Clear browsing data".</div>' +
          '<div style="margin: 10px 0;">Safari:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Open Safari;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Choose Safari > Preferences, and then click Privacy;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Click Details;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>Select one or more websites that store cookies, and then click Remove or Remove All;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>When you finish removing websites, click Done.</div>' +
          '<div style="margin: 10px 0;">Mozilla Firefox:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Choose Tools;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Select options;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Select the Privacy tab;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>Choose Remove individual cookies.</div>' +
          '<div style="margin: 10px 0;">Internet Explorer:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Choose Tools;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Select Internet Options;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Select the General tab;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>Press delete to delete all cookies.</div>' +
          '<div style="margin: 10px 0;">On your iPhone:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>From the Home screen, choose Settings > Safari;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Tap Clear Cookies.</div>' +
          '<div style="margin: 10px 0;">iPhone iOS 8 or iOS 9:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Launch Settings app;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Scroll down and tap on Safari;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Tap on Clear History and Website Data;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>Confirm it by tapping on Clear History and Website Data from the bottom.</div>' +
          '<div style="margin: 10px 0;">On your Android:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Launch your browser;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Press the Menu key, then press More;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>Press Settings;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>Scroll down to the Privacy Settings section;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>5.&nbsp;</i>Press Clear All Cookie Data;</div>' +
          '<div style="margin-left: 15px;display: flex"><i>6.&nbsp;</i>Press OK.</div>'
      },
      {
        subTitle: 'How to take a screenshot?',
        content:
          '<div>Here are some examples:</div>' +
          '<div style="margin: 10px 0;">On your Android:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Press the Power button and Volume down key at the same time.</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Hold both buttons for a second, until you hear a shutter sound or see a visual indicating a picture has been taken.</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>You need to hold the Power button slightly before pressing the Volume down button, then hold them both down.</div>' +
          '<div style="margin-left: 15px;display: flex"><i>4.&nbsp;</i>It may take a few tries.</div>' +
          '<div style="margin-top: 10px;">This technique works with the following devices, as well as most Android phones that came out after 2013:</div>' +
          '<div style="margin-top: 10px;">The Samsung Galaxy S9, Galaxy S9 Plus, Galaxy S8, Galaxy S8 Plus, Galaxy S7, Galaxy S7 Edge, Galaxy S6, Galaxy S6 Edge, Galaxy S6 Edge Plus, Galaxy S5, Galaxy S4, Galaxy Note 8, Galaxy Note 5, Galaxy Note 4, and Galaxy Note 3.</div>' +
          '<div style="margin: 10px 0;">On your iPhone X or later:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Press the side button and the volume up button at the same time.</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Quickly release both buttons.</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>After you take a screenshot, a thumbnail temporarily appears in the lower-left corner of your screen. Tap the thumbnail to open it or swipe left to dismiss it.</div>' +
          '<div style="margin-top: 10px;">The Samsung Galaxy S9, Galaxy S9 Plus, Galaxy S8, Galaxy S8 Plus, Galaxy S7, Galaxy S7 Edge, Galaxy S6, Galaxy S6 Edge, Galaxy S6 Edge Plus, Galaxy S5, Galaxy S4, Galaxy Note 8, Galaxy Note 5, Galaxy Note 4, and Galaxy Note 3.</div>' +
          '<div style="margin: 10px 0;">On your iPhone 8, 7, or 6:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Press the side button and the Home button at the same time.</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Quickly release both buttons.</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>After you take a screenshot, a thumbnail temporarily appears in the lower-left corner of your screen. Tap the thumbnail to open it or swipe left to dismiss it.</div>' +
          '<div style="margin: 10px 0;">On your iPhone SE, 5, or earlier:</div>' +
          '<div style="margin-left: 15px;display: flex"><i>1.&nbsp;</i>Press the top button and the Home button at the same time.</div>' +
          '<div style="margin-left: 15px;display: flex"><i>2.&nbsp;</i>Quickly release both buttons.</div>' +
          '<div style="margin-left: 15px;display: flex"><i>3.&nbsp;</i>After you take a screenshot, a thumbnail temporarily appears in the lower-left corner of your screen. Tap the thumbnail to open it or swipe left to dismiss it.</div>'
      }
    ]
  },
  copyRight: '© 2022 PGEbet All rights reserved. DM Global Ltd (Company). Tenancy 10, Marina House, Eden Island, Mahe, Seychelles.'
}



// WEBPACK FOOTER //
// ./src/assets/locale/zh-CN.js